import declint from 'declint-ru'

const formatReload = reload => `${reload} ${declint(reload, ['выстрел', 'выстрела', 'выстрелов'])}`

export default formatReload
